<!--
 * @FileDescription: 子菜单入口（注释描述）
 * @Author: ryb（作者）
 * @Date: 2020-04-13（时间）
 * @LastEditors: ryb（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div>
    <keep-alive :max="20" :include="keepAliveList">
      <router-view v-if="isRouterFlows"/>
    </keep-alive>
  </div>
</template>
<script>
export default {
  name: "SecondView",
  data () {
    return {
      keepAliveList: '',
        isRouterFlows:true
    }
  },
  computed: {
    keepAlive () {
      return this.$store.state.keepAlive
    },
      isRouterFlow(){
        return this.$store.state.isRouterFlow
      }
  },
  watch: {
    keepAlive () {
      this.keepAliveList = this.$store.state.keepAlive
    },
      isRouterFlow(){
        this.isRouterFlows = this.$store.state.isRouterFlow
      }
  }
}
</script>
